import React from 'react';
import { TableCell, TableRow, Tooltip } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { checkPermission } from '../../utils_v2';
import { hanwahaInstance } from '../../../shared/components';
import ReadMoreInline from '../../../shared/components/ReadMoreInline';
const InventoryList = ({item, onView, onEdit, onDelete, onOpenAttachments, pltConstants}) => {
    return(
        <TableRow>
             <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 10, width: '140px' }}>
                <div style={{minWidth:'140px'}}>
                    <ul className='list-inline flex-centered' >
                        <li style={{cursor:'pointer'}} className='list-inline-item' onClick={onView}>
                            <Tooltip title='View'><VisibilityIcon fontSize='small' color='primary' /></Tooltip>
                        </li>
                        {checkPermission('technical_specs', 'inventory', 'U') ?
                            <li style={{cursor:'pointer'}} onClick={onEdit} className='list-inline-item'>
                                <Tooltip title='Edit'><EditIcon color='primary' fontSize='small' /></Tooltip>
                            </li>:null
                        }
                        { checkPermission('technical_specs', 'inventory', 'D') ?
                            <li style={{cursor:'pointer'}} onClick={onDelete} className='list-inline-item'>
                                <Tooltip title='Delete'><DeleteOutlineIcon color='secondary' fontSize='small' /></Tooltip>
                            </li>:null
                        }
                            {item.attachments.length?
                            <li style={{cursor:'pointer'}} onClick={onOpenAttachments} className='list-inline-item'>
                                <span className='flex-centered'>
                                    <span>({item.attachments.length})</span>
                                    <AttachFileIcon color='primary' fontSize='small' />
                                </span>
                                
                            </li>:null
                        }
                    </ul>
                </div>
            </TableCell>
            <TableCell>{item?.description||'--'}</TableCell>
            {hanwahaInstance ?
                <TableCell>{item?.inventory_type?.name||'--'}</TableCell> : null
            }
            <TableCell>{item.serial_number}</TableCell>
            <TableCell>{item?.part_number||'--'}</TableCell>
            <TableCell>{item?.owner||'--'}</TableCell>
            <TableCell >{item?.location||'--'}</TableCell>
            <TableCell>{item?.linked_asset||'--'}</TableCell>
            {hanwahaInstance?
                <TableCell>{item?.reference||'--'}</TableCell>
            :null}
            {hanwahaInstance ?
                <>
                    <TableCell>{item?.seller||'--'}</TableCell>
                    <TableCell>{item?.lessee||'--'}</TableCell>
                    <TableCell style={{maxWidth:'300px'}}>{<ReadMoreInline text={item?.asset_location} maxLength='50' />}</TableCell>
                    <TableCell>{ (pltConstants?.find(i=> i?.value ==item?.asset_status)?.label||'--') }</TableCell>
                </>
                :
                <TableCell>{item?.status||'--'}</TableCell>
            }
            {hanwahaInstance ?
                <TableCell>
                     <ReadMoreInline text={item?.remarks} maxLength='30' /></TableCell> : null
            }
           
        </TableRow>
    )
}
export default InventoryList;